export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>At BGGM Finance, We are available to help with your accountancy and financial services need by providing support to make your good business grows. <br/> We use market leading cloud-based accountancy platforms to deliver maximum efficiency and features to help you run your business more effectively. <br /> We serve a variety of micro, small, and medium-sized businesses, including limited companies and charities.</p>
                <a
                  href='#features'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  Learn More
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
